import { TENANT_PARAM } from "src/services/tenantUrl";

/** Shareable query param: ?designOption=<option-uuid>. Omitted for trunk/baseline. */
export const DESIGN_OPTION_PARAM = "designOption";

export const readDesignOptionFromSearch = (
  search: string
): string | undefined => {
  const value = new URLSearchParams(search).get(DESIGN_OPTION_PARAM);
  return value || undefined;
};

/** designOption first, then tenant, then any other params (insertion order). */
export const buildDesignOptionSearch = (
  currentSearch: string,
  designOptionId: string | undefined,
  tenant: string | null | undefined
): string => {
  const rest = new URLSearchParams(currentSearch);
  rest.delete(DESIGN_OPTION_PARAM);
  rest.delete(TENANT_PARAM);

  const params = new URLSearchParams();
  if (designOptionId) {
    params.set(DESIGN_OPTION_PARAM, designOptionId);
  }
  if (tenant) {
    params.set(TENANT_PARAM, tenant);
  }
  rest.forEach((value, key) => {
    params.append(key, value);
  });
  return params.toString();
};
